import AccountingPermissions from "./AccountingPermissions";
import AdminPermissions from "./AdminPermissions";
import AnswerReviewPermissions from "./AnswerReviewPermissions";
import ApiToolPermissions from "./ApiToolPermissions";
import CallsPermissions from "./CallsPermissions";
import ChatbotPermissions from "./ChatbotPermissions";
import ChatPermissions from "./ChatPermissions";
import FollowupPermissions from "./FollowupPermissions";
import KnowledgebasePermissions from "./KnowledgeBasePermissions";
import PlanPermissions from "./PlanPermissions";
import PricePermissions from "./PricePermissions";
import SettingsPermissions from "./SettingsPermissions";
import UserPermissions from "./UserPermissions";
import VoicebotPermissions from "./VoicebotPermissions";
export const abilities = {
    ...KnowledgebasePermissions,
    ...ChatbotPermissions,
    ...ChatPermissions,
    ...UserPermissions,
    ...SettingsPermissions,
    ...ApiToolPermissions,
    ...AnswerReviewPermissions,
    ...FollowupPermissions,
    ...VoicebotPermissions,
    ...AdminPermissions,
    ...CallsPermissions,
    ...AccountingPermissions,
    ...PlanPermissions,
    ...PricePermissions,
};
export const may = (session, path, action, resource) => {
    if (!action) {
        action = "index";
    }
    if (abilities[path]) {
        const fun = (abilities[path][action] || abilities[path].index || (() => false));
        return fun(session, resource);
    }
    return false;
};
